import { ProductItem, Text } from 'components';
import React from 'react';
import { ProductAttributesFromCategories } from 'services/menu/menu.type';
import { ListContainer, ProductListContainer, ProductListTitle } from './ProductList.style';

type Props = {
    productList: ProductAttributesFromCategories[];
    title: string;
    currency: string;
    onProductClick?: (id: number) => void;
};

const ProductList: React.FunctionComponent<Props> = ({
    productList,
    currency,
    title,
    onProductClick,
}) => {
    return (
        <ProductListContainer>
            <ProductListTitle text={title} noTranslation weight="bold" />
            <ListContainer>
                {productList.length ? (
                    productList
                        .filter(({ webAvailability }) => webAvailability)
                        .map((product) => (
                            <ProductItem
                                {...product}
                                key={product.productId}
                                currency={currency}
                                onClick={onProductClick}
                            />
                        ))
                ) : (
                    <Text text={'empty_product_list'} />
                )}
            </ListContainer>
        </ProductListContainer>
    );
};

export default ProductList;
